import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DropdownModule } from 'primeng/dropdown';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PanelModule } from 'primeng/panel';
import { CheckboxModule } from 'primeng/checkbox';

import { TabViewModule } from 'primeng/tabview';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';
import { TagModule } from 'primeng/tag';
import { InputTextarea } from 'primeng/inputtextarea';
import { DialogModule } from 'primeng/dialog';
import { EditorModule } from 'primeng/editor';
import { InputMaskModule } from 'primeng/inputmask';
import { ServicesTypesListComponent } from './services-types-list/services-types-list.component';
import { ServicesTypesDetailComponent } from './services-types-detail/services-types-detail.component';
import { ServicesTypesRoutingModule } from './services-types-routing.module';
import { ServiceTypeCompanyComponent } from './services-types-detail/services-types-company/services-types-company.component';
import { MultiSelectModule } from 'primeng/multiselect';


import { CoreModule } from 'src/app/core/core.module';
@NgModule({ declarations: [
        ServicesTypesListComponent,
        ServicesTypesDetailComponent,
        ServiceTypeCompanyComponent
    ], imports: [CoreModule,
        ServicesTypesRoutingModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        TableModule,
        CardModule,
        ButtonModule,
        InputTextModule,
        InputNumberModule,
        InputMaskModule,
        InputSwitchModule,
        DropdownModule,
        ConfirmDialogModule,
        PanelModule,
        CheckboxModule,
        TabViewModule,
        CalendarModule,
        TagModule,
        InputTextarea,
        DropdownModule,
        DialogModule,
        EditorModule,
        MultiSelectModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class ServicesTypesModule { }
